<template>

</template>

<script>
import supportRepository from "../repositories/support";
import websocketEventBus from "../eventBus/websocketEventBus";

export default {
  name: "InitSupport",
  methods: {
    getMessageCount(){
      supportRepository.messageCount()
          .then(resp => {
            this.$store.dispatch("updateSupportMessageCount", resp.data.count);
          })
          .catch((err) => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    },
  },
  created() {
    setTimeout(() => this.getMessageCount(), 3000);
    websocketEventBus.subscribeToNewSupport(this.getMessageCount);
  },
  beforeDestroy() {
    websocketEventBus.unsubscribeFromNewSupport(this.getMessageCount);
  },
};
</script>
